import theme from 'site-react/theme';
import { css } from 'emotion';

/**
 * Common CSS applied across the footer
 */
export const footerContentPadding = css`
  padding: ${theme.spacing.xxl}px ${theme.spacing.md}px;

  /* Left-right padding for tablets (+ larger devices), should be more */
  @media (min-width: ${theme.breakpoints.md}px) {
    padding: ${theme.spacing.xxl}px ${theme.spacing.lg}px;
  }
`;

export const footerLineBreakBottom = css`
  border-bottom: 1px solid ${theme.colors.neutral600};
`;

export const footerSmallTextStyle = css`
  ${theme.contentText3};
  color: ${theme.colors.neutral200};
  display: inline-block;
  margin: 0;
  text-align: center;
  width: 100%;
`;

export const footerRegularTextStyle = css`
  ${theme.contentText2};
  color: ${theme.colors.neutral200};
  display: inline-block;
  margin: 0;
  text-align: center;
  width: 100%;
`;

export const footerLinkStyle = css`
  color: ${theme.colors.white};
  text-decoration: none;
  transition: all 0.25s ease-in-out;

  &:hover,
  &:focus,
  &:active {
    color: ${theme.colors.white};
    text-decoration: underline;
    & > span {
      text-decoration: underline;
    }
  }
`;
